import { mapState } from "vuex";
import * as ACTIONS from "@/config/constants/action-types";
const log = console;

export default {
  install(Vue) {
    Vue.mixin({
      computed: {
        ...mapState({
          m_preloadSdk: state => state.sdk.preload,
          m_isIframeSdkVisible: state => state.sdk.isVisible,
          m_iframe: state => state.sdk.iframe
        })
      },
      methods: {
        showVeridasSdk() {
          this.$store.dispatch(ACTIONS.DO_IS_VISIBLE_SDK, true);
          document.getElementsByTagName("body")[0].classList.add("lock-scroll");
          if (this.m_iframe?.contentWindow) {
            const element = document.body;
            if (element.requestFullscreen) {
              element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
              /* Firefox */
              element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
              /* Chrome, Safari and Opera */
            } else if (element.msRequestFullscreen) {
              /* IE/Edge */
              element.msRequestFullscreen();
            }
          }
        },
        hideVeridasSdk() {
          try {
            // Salir de fullscreen de forma compatible
            if (document.fullscreenElement) {
              document.exitFullscreen();
            } else if (document.webkitFullscreenElement) {
              document.webkitExitFullscreen();
            } else if (document.mozFullScreenElement) {
              document.mozCancelFullScreen();
            } else if (document.msFullscreenElement) {
              document.msExitFullscreen();
            }
          } catch (error) {
            log.error(error);
          }
          this.$store.dispatch(ACTIONS.DO_IS_VISIBLE_SDK, false);
          document
            .getElementsByTagName("body")[0]
            .classList.remove("lock-scroll");
        },
        preloadSdk() {
          this.$store.dispatch(ACTIONS.DO_PRELOAD_SDK, true);
          setTimeout(() => {
            const iframe = document.getElementById("XpressID-iframe");
            this.$store.dispatch(ACTIONS.DO_SAVE_IFRAME, iframe);
          }, 500);
        },
        destroySdk() {
          this.$store.dispatch(ACTIONS.DO_SAVE_IFRAME, null);
          this.$store.dispatch(ACTIONS.DO_PRELOAD_SDK, false);
        },
        reloadSdk() {
          if (this.m_iframe && this.m_iframe.contentWindow) {
            this.m_iframe.contentWindow.location.reload();
          }
        },
        setTestingSdk() {
          // Configura el iframe para pruebas de tagging
          // y actions
          this.m_iframe.src = "xpressid-events.html";
        }
      }
    });
  }
};
